import { Link } from "react-router-dom";
import HavnsLogo from "./HavnsLogo";

const Footer = ({ bgColor = "bg-white" }) => {
  return (
    <footer className={`py-12 ${bgColor} border-t border-[#EEE]`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <HavnsLogo className="text-xl" linkTo="/" />
          
          {/* Links */}
          <div className="flex items-center gap-6 md:gap-8 text-sm">
            <Link 
              to="/manifesto" 
              className="text-[#666] hover:text-[#1A1A1A] transition-colors"
            >
              Anti-Dating Manifesto
            </Link>
            <Link 
              to="/privacy" 
              className="text-[#666] hover:text-[#1A1A1A] transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className="text-[#666] hover:text-[#1A1A1A] transition-colors"
            >
              Terms of Service
            </Link>
          </div>
          
          {/* Copyright */}
          <p className="text-[#999] text-sm">
            © {new Date().getFullYear()} Havns
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
